<template>
  <div :class="componentClassName">
    <div class="a-notice-header__title">
      <div class="a-notice-header__icon">
        <i v-if="existNew" class="a-notice-header__indicator-new-notice" />
        <a-icon :icon="headericon" />
      </div>
      <slot>{{ title }}</slot>
    </div>
    <div class="a-notice-header__close-button">
      <a-button id="notice-close" variant="icon" :icon="icon" icon-color="white" @click="viewMode" />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AIcon from '@/components/atoms/icon';
export default {
  name: 'a-notice-header',
  components: {
    AButton,
    AIcon,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    headericon: {
      type: String,
      default: 'bell-outline',
    },
    icon: {
      type: String,
      default: 'minimize',
    },
    iconColor: {
      type: String,
      default: 'white',
    },
    withBorder: {
      type: Boolean,
      default: true,
    },
    existNew: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['mode'],
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-notice-header', this.withBorder ? 'border' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    viewMode(event) {
      this.$emit('mode', event);
    },
  },
};
</script>
